import type { Components } from '@/api/generated/api';
import { ESchoolYearStatus } from 'common/enum/misc.enum';
import { now } from 'common/utils/date.utils';
import { useI18n } from 'vue-i18n';

interface IUseSchoolYearStatus {
  getStatus: (schoolYear: Components.Schemas.SchoolYearDto) => ESchoolYearStatus;
  getStatusName: (schoolYear: Components.Schemas.SchoolYearDto) => string;
  isSchoolYearInFuture: (schoolYear: Components.Schemas.SchoolYearDto) => boolean;
}

export function useSchoolYearStatus(): IUseSchoolYearStatus {
  const { t } = useI18n();

  const getStatus = (schoolYear: Components.Schemas.SchoolYearDto): ESchoolYearStatus => {
    const currentDate = now();
    const startDate = new Date(schoolYear.schoolYearStart);
    const endDate = new Date(schoolYear.schoolYearEnd);
    if (currentDate < startDate) {
      return ESchoolYearStatus.UPCOMING;
    }
    if (currentDate >= startDate && currentDate <= endDate) {
      return ESchoolYearStatus.ACTIVE;
    }
    return ESchoolYearStatus.PAST;
  };

  const isSchoolYearInFuture = (schoolYear: Components.Schemas.SchoolYearDto): boolean => {
    return now() < new Date(schoolYear.schoolYearStart);
  };

  const getStatusName = (schoolYear: Components.Schemas.SchoolYearDto): string => {
    return t(`schoolYears.status.${getStatus(schoolYear)}`);
  };

  return { getStatus, getStatusName, isSchoolYearInFuture };
}
